import { createStore } from "vuex";
import productModalModule from "./productModalModule";
import cartModule from "./cartModule";
import orderToastModule from "./orderToastModule";
import userModule from "./userModule";
import cardModule from "./cardModule";
import findStationModule from "./findStationModule";
import resetPasswordModule from "./resetPasswordModule";
import notificationsModule from "./notificationsModule";
import onboardingModule from "./onboardingModule";
import payDebtModule from "./payDebtModule";
import resendPhoneCodeModule from "./resendPhoneCodeModule";
import orderModule from "./orderModule";
import debtsModalModule from "@/storeGlobal/debtsModalModule";
import orderDetailsModule from "@/storeGlobal/orderDetailsModule";
import noCreditCardModalModule from "@/storeGlobal/noCreditCardModalModule";
import pollModule from "@/storeGlobal/pollModule";
import forcePasswordChangeModule from "@/storeGlobal/forcePasswordChangeModule";

const store = createStore({
  modules: {
    productModal: productModalModule,
    cart: cartModule,
    orderToast: orderToastModule,
    order: orderModule,
    findStation: findStationModule,
    resetPassword: resetPasswordModule,
    user: userModule,
    card: cardModule,
    notifications: notificationsModule,
    onboarding: onboardingModule,
    payDebt: payDebtModule,
    resendPhoneCode: resendPhoneCodeModule,
    debtsModule: debtsModalModule,
    orderDetails: orderDetailsModule,
    noCreditCardModal: noCreditCardModalModule,
    poll: pollModule,
    forcePasswordChange: forcePasswordChangeModule,
  },
  actions: {
    logout({ commit }) {
      // Clear user/auth state here
      commit("CLEAR_AUTH");
      // Optionally clear other state or localStorage
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      // Redirect to login or home page
      window.location.href = "/login";
    },
  },
  mutations: {
    CLEAR_AUTH(state) {
      state.user = null;
      state.token = null;
      // ...clear other auth-related state...
    },
  },
});

export default store;
